<template>
    <div class="container">
        <div class="row">
            <div class="col-sm-12 title">
                Klassische suche (Alle anderen hersteller)
            </div>
        </div>
        <div class="row">
            <div class="col-sm-2">
                <div class="filterText">Hersteller</div>
                <div class="filterText">Modell</div>
                <div class="filterText">Typ</div>
            </div>
            <div class="col-sm-7">
                <div class="filterInputContainer">
                    <div class="form-group">
                        <select class="form-control" name="brand" @change="onChangeBrand" v-model="form.brand">
                            <option :value="0" disabled hidden>--- Hersteller wählen ---</option>
                            <option v-for="brand in brands" :data-id="brand.id" :value="brand.id">{{brand.description}}</option>
                        </select>
                    </div>
                </div>
                <div class="filterInputContainer">
                    <div class="form-group">
                        <select :class="modelDisabled" name="model" @change="onChangeModel" v-model="form.model">
                            <option :value="0" disabled hidden>--- Modellwählen ---</option>
                            <option v-for="model in models" :data-id="model.id" :value="model.id">{{model.description}}</option>
                        </select>
                    </div>
                </div>
                <div class="filterInputContainer">
                    <div class="form-group">
                        <select :class="typeDisabled" name="type" @change="onChangeType" v-model="form.type">
                            <option :value="0" disabled hidden>--- Typ wählen ---</option>
                            <option v-for="type in types" :data-id="type.id" :value="type.id">{{type.description}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <button :class="buttonDisabled" @click="onClick"><i v-if="loading" class="fa fa-spin fa-spinner fa-fw"></i>suchen</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    brand: 0,
                    model: 0,
                    type: 0
                }),
                brands: [],
                models: [],
                types: [],
                selCar: [],
                loading: false
            }
        },

        computed: {
            modelDisabled() {
                return this.form.brand != 0 ? 'form-control' : 'form-control disabled';
            },
            typeDisabled() {
                return this.form.model != 0  ? 'form-control' : 'form-control disabled';
            },
            buttonDisabled() {
                return this.form.type != 0  ? 'btn' : 'btn disabled';
            }
        },

        methods: {
            onChangeBrand(e) {
                let select = e.currentTarget;
                if(select.options[select.selectedIndex].dataset.id == 0) {
                    this.form.brand = 0;
                    this.form.model = 0;
                    this.form.type = 0;
                    this.selCar = [];
                } else {
                    this.form.model = 0;
                    this.form.type = 0;
                    this.selCar = [];
                    new Form({id: select.options[select.selectedIndex].dataset.id})
                        .post('/api/models')
                        .then((models) => {
                            this.models = models;
                        });
                }
            },

            onChangeModel(e) {
                let select = e.currentTarget;
                if(select.options[select.selectedIndex].dataset.id == 0) {
                    this.form.model = 0;
                    this.form.type = 0;
                    this.selCar = [];
                } else {
                    this.form.type = 0;
                    this.selCar = [];
                    new Form({id: select.options[select.selectedIndex].dataset.id})
                        .post('/api/allTypes')
                        .then((types) => {
                            this.types = types;
                        });
                }
            },

            onChangeType(e) {
                let select = e.currentTarget;
                new Form({id: select.options[select.selectedIndex].dataset.id})
                    .post('/api/getKBA')
                    .then((response) => {
                        this.selCar = response;
                    });
            },

            onClick() {
                this.loading = true;
                window.location = App.url+'/search?searcType=car&Suche='+this.selCar.kba1+'&Suche2='+this.selCar.kba2+'&carId='+this.selCar.id;
            },
        },
        created() {
            App.event.listen('car.all.brands.loaded', (brands) => {
                this.brands = brands;
                this.form.brand = 0;
                this.form.model = 0;
                this.form.type = 0;
                this.form.selCar = 0;
            });
        },
    }
</script>